/**
 * ログイン後に 1 回だけ引く viewer を、配下の画面へ配る。
 *
 * テナントはトークンのクレームから決まるので、画面は「いまどのテナントを見ているか」を
 * 自分で持たない。viewer.tenant がその答えである。
 */

import { createContext, useContext, type ReactNode } from "react";
import { useQuery } from "urql";
import {
  ErrorState,
  LoadingState,
  ViewerDocument,
  type ViewerQuery,
} from "visumo-data-agent-web-shared";

export type ViewerData = NonNullable<ViewerQuery["viewer"]>;

const ViewerContext = createContext<ViewerData | null>(null);

export function ViewerProvider({ children }: { children: ReactNode }) {
  const [result, refetch] = useQuery({ query: ViewerDocument });

  if (result.fetching && result.data === undefined) {
    return <LoadingState label="アカウントを確かめています" />;
  }
  if (result.error !== undefined || result.data === undefined) {
    return (
      <ErrorState
        title="アカウント情報を読み込めませんでした"
        description={result.error?.message}
        onRetry={() => refetch({ requestPolicy: "network-only" })}
      />
    );
  }
  return (
    <ViewerContext.Provider value={result.data.viewer}>
      {children}
    </ViewerContext.Provider>
  );
}

export function useViewer(): ViewerData {
  const viewer = useContext(ViewerContext);
  if (viewer === null) {
    throw new Error("ViewerProvider の外で useViewer を呼んでいます");
  }
  return viewer;
}
